<template>
  <div v-if="submitted" class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <pre v-html="value.answer.content" class="grey--text text--darken-2" />
  </div>
  <div v-else class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <v-combobox v-if="value.question.allowOther"
      @change="update"
      :value="value.answer.content"
      placeholder="Select or type an answer"
      :items="value.question.options"
      :color="themes.candidate.light.input"
      :clearable="value.question.optional"
      :required="!value.question.optional"
    />
    <v-select v-else
      @change="update"
      :value="value.answer.content"
      placeholder="Select an answer"
      :items="value.question.options"
      :color="themes.candidate.light.input"
      :clearable="value.question.optional"
      :required="!value.question.optional"
    />
  </div>
</template>

<script>
// Vue Component
export default {
  props: { value: Object, submitted: Boolean },
  methods: {
    update(event) {
      const content = event || null
      this.$emit('saving')
      if (this.value.answer.id) {
        this.$http
          .patch(`candidate/answers/${this.value.answer.id}`, {
            answer: Object.assign(this.value.answer, { content }),
          })
          .then(response => {
            this.value.answer = response.data
            this.$emit('saved')
          })
      } else {
        this.$http
          .post('candidate/answers', {
            answer: Object.assign(this.value.answer, { content }),
          })
          .then(response => {
            this.value.answer = response.data
            this.$emit('saved')
          })
      }
    },
  }
}
</script>

<style scoped>
pre {
  font-family: 'Heebo';
  white-space: pre-line;
}
</style>
